<template>
  <div class="sidebar">
    <div class="logo-holder">
      <h1 class="logo"><router-link :to="{name: 'performance'}">RADIUS</router-link></h1>
    </div>
    <nav class="navigation">
      <div class="user-info" :class="{employee: employee}">
        <div v-if="!employee" class="aff-info">
          <p>{{ $store.state.user.first_name }} {{ $store.state.user.last_name }}</p>
        </div>
        <el-select v-else
            filterable
            remote
            v-model="affiliate"
            value-key="affiliate_id"
            :remoteMethod="searchAffiliates"
            @focus="searchAffiliates('')"
            :placeholder="affiliate.label || 'Master Affiliate'"
            :loading="affLoading"
            loading-text="Loading..."
            no-data-text="No Matches"
            popper-class="sidebar-select"
            @keydown.native="selectAffiliate">
            <el-option
              v-for="item in $store.state.cache.affiliateList"
              :key="item.affiliate_id"
              :label="item.label"
              :value="item">
              <span class="label">{{ item.label }}</span>
              <span class="value">{{ item.affiliate_id }}</span>
            </el-option>
        </el-select>
        <h5 class="aff-id">{{ affiliate.affiliate_id }}</h5>
        <span class="divide"></span>
        <div  v-if="manager" class="aff-mngr">
          <div class="aff-mngr-img">
            <img v-if="manager.image" :src="manager.image"/>
          </div>
          <div class="aff-mngr-info">
            <p>Affiliate Manager</p>
            <p>{{ manager.first_name }} {{ manager.last_name }}</p>
          </div>
        </div>
      </div>
      <ul class="navigation-items">
        <li @click="hideMenu" class="navigation-item"><router-link :to="{name: 'performance'}">Performance</router-link></li>
        <li @click="hideMenu" class="navigation-item"><router-link :to="{name: 'rotator'}">Rotator</router-link></li>
        <li @click="hideMenu" class="navigation-item" v-if="$store.getters.isImpersonated"><router-link :to="{name: 'setting'}">Settings</router-link></li>
        <li @click="hideMenu() && logout()" class="navigation-item logout-btn"><i class="el-icon-arrow-left"></i> Logout</li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
  data() {
    return {
      affiliate       : { affiliate_id: this.$store.state.user.affiliate_id, label: this.$store.state.user.company },
      searchString    : null,
      affiliates      : [],
      affiliateList   : [],
      affLoading      : false
    }
  },
  computed: {
    employee() {
      return this.$store.getters.isEmployee
    },
    manager() {
      return this.$store.state.user.manager != null? this.$store.state.user.manager : false;
    }
  },
  watch: {
    affiliate(newVal, oldVal) {
      this.$store.dispatch('affiliate', { id: newVal.affiliate_id, company: newVal.label })
    },
    '$store.state.user.affiliate_id'(newVal) {
      this.affiliate = { affiliate_id: this.$store.state.user.affiliate_id, label: this.$store.state.user.company }
    },
    '$store.state.cache.affiliateList'() {
      this.affLoading = false
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    hideMenu() {
      this.$store.commit('setPanel', null);
      return true;
    },
    searchAffiliates(q) {
      if (this.affiliate && this.affiliate.label && this.$store.state.cache.affiliateList.length > 1 &&
          (!q || q == '' || this.affiliate.label.toLowerCase() == q.toLowerCase()))
        return

      this.affLoading = true;
      this.$store.dispatch('searchAffiliates', q || '');
    },
    selectAffiliate(e) {
      if (e.keyCode == 13)
        $('.sidebar-select li.hover:eq(0)').length
          ? $('.sidebar-select li.hover:eq(0)').click()
          : $('.sidebar-select li:visible:eq(0)').click()
    }
  }
};
</script>
<style lang="scss">

.sidebar {
  z-index: 1000 !important;
}
.sidebar-select .value {
  float: right;
  color: #8492a6;
  font-size: 13px;
}
.sidebar-select .label {
  float: left;
  width: 225px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-select .selected .value {
  color: #e5e5e5;
}
.login-as {
  position: fixed;
  top: 1em;
  right: 1em;
}
.logo-holder a{
  color: #fff;
  text-decoration: none;
}

/*
 * SIDEBAR
 */

.sidebar
{ /*Sidebar*/
  background: aliceblue;
  height: inherit;
  position: fixed;
  left: -100%;
  z-index: 250;
  overflow: hidden;
  transition: left .2s;
  width: 70%;
  max-width: 250px;

  .logo-holder
  { /*Logo Holder*/
    background: linear-gradient(140deg, #007ED1, #008CD6);
    padding: 0;
    height: 50px;
    position: relative;

    .logo{
      font-family: 'Fjalla One', Arial;
      color: #fff;
      font-size: 40px;
      padding: 5px 15px;
    }
  }

  .navigation
  { /*Navigation*/
  	padding: 15px 15px 0 15px;
  	position: relative;
  	height: calc(100% - 50px);
    overflow-y: auto;
  	background-color: #F6F9F9;

    .navigation-items {
      height: calc(100% - 180px);
      min-height: 275px;
      position: relative;
    }
    .navigation-item
    { /*Naivation Item*/
      margin: 0px 0 15px 0;
      cursor: pointer;
      font-size: 19px;
      width: inherit;

      &.logout-btn
      { /*Logout Button*/
        position: absolute;
        bottom: 0px;
        left: 15px;
        font-size: 14px;

        .el-icon-arrow-left{
          font-size: 10px;
          margin-right: 8px;
          height: 16px;
          width: 16px;
          display: inline-block;
          position: relative;
          line-height: 16px;
          text-indent: 2px;
          transition:  all 0.3s;
          border-radius: 30px;
        }
        &:hover{
          font-weight: bold;

          .el-icon-arrow-left{
            background: #555;
            color: #fff;
          }
        }
      }
      a{
        text-decoration: none;
        width: inherit;
        padding: 10px 15px;
        color: #242424;
        display: block;
        height: 40px;
        line-height: 20px;
        font-size: 16px;
        background: #F6F9F9;
        transition: background color 0.3s linear;
        border-radius: 5px;

        &.router-link-active,
        &:hover{
          background: #007ED1;
          color: #fff;
          text-shadow: 0 0 1px #333;
        }
      }
    }
    .user-info
    { /*User Info*/
      margin: 15px 0 55px;

      .divide{
        width: 100%;
        display: block;
        height: 1px;
        background-color: #ececec;
        box-shadow: 0 0 2px -1px #000;
        margin: 10px 0;
      }
      .aff-info p{
        font-size: 16px;
        font-weight: bold;
        font-family: 'Istok Web', Helvetica, sans-serif;
        margin: 15px 0px;
        text-align: left;
        margin-left: 53px;
      }
      .aff-id {
        font-size: 0.9em;
        color: grey;
        margin-left: 53px;
        top: -12px;
        position: relative;
      }

      .el-select .el-input__inner{
        font-size: 16px;
        font-weight: bold;
        font-family: 'Istok Web', Helvetica, sans-serif;
        margin: 15px 0px;
        text-align: left;
        border: none;
        background-color: transparent;
      }
      .aff-mngr-img,
      .aff-mngr-info{
        display: inline-block;
        vertical-align: middle;

        &.aff-mngr-img{
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          box-shadow: 1px 1px 1px 0 #555;

          img{
            width: 100%;
          }
        }
      }

      .el-input__inner::-webkit-input-placeholder {
        color: #606266;
      }
      .el-input__inner:-ms-input-placeholder {
        color: #606266;
      }
      .el-input__inner::-ms-input-placeholder {
        color: #606266;
      }
      .el-input__inner::-moz-placeholder {
        color: #606266;
      }
      .el-input__inner::placeholder {
        color: #606266;
      }

      &.employee .aff-id {
        padding-left: 15px;
        margin: -20px auto 30px;
        position: static;
      }
    }
  }

  .aff-mngr-info p:first-child{
    font-size: 14px;
    font-family: 'Istok Web', Helvetica, sans-serif;
    font-weight: 600;
  }
}

@media(max-width: 768px){
  .sidebar .navigation {

    .navigation-items {
      height: calc(100% - 150px);
    }
    .user-info {
      margin: 15px 0 25px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// sidebar.vue?413a678c